export const authTypes = {
  standard: "standard",
  facebook: "facebook",
  apple: "apple",
  google: "google",
};
